// src/components/TwoFactorPrompt.jsx
//
// Top-right suggestion shown right after a login (password or Face ID) when
// the account still uses email codes. "Enable 2FA" opens the Security page
// straight at the password step. Shown again on the next login until the
// authenticator app is set up. Same card anatomy as the Security page
// (mockup 1a/1b).
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiFetchJSON } from '../api/apiClient';
import '../pages/SecurityPage.css';

export default function TwoFactorPrompt({ onDismiss }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [needed, setNeeded] = useState(false);

  useEffect(() => {
    let alive = true;
    apiFetchJSON('/api/account/security')
      .then((s) => { if (alive) setNeeded(!s.totp_enabled); })
      .catch(() => { /* not important enough to surface */ });
    return () => { alive = false; };
  }, []);

  if (!needed || location.pathname === '/security') return null;

  const enable = () => {
    onDismiss();
    navigate('/security?setup=1');
  };

  return (
    <div className="sec-toast" role="dialog" aria-label="Enable two-factor authentication">
      <div className="sec-body">
        <div className="sec-step-title">Enable 2FA</div>
        <p className="sec-text-muted">
          With two-factor authentication, you can confirm your identity with an extra
          security feature in addition to your username and password.
        </p>
        <div className="sec-footer">
          <button type="button" className="sec-btn-secondary" onClick={onDismiss}>Not now</button>
          <button type="button" className="sec-btn-primary" onClick={enable}>Enable 2FA</button>
        </div>
      </div>
    </div>
  );
}
